import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    if (err.response?.status === 401 && !cfg._retry && !cfg.url?.includes("/auth/")) {
      cfg._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => (refreshing = null));
      try { await refreshing; return api(cfg); } catch (e) { /* fallthrough */ }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x?.msg ? `${x.loc ? x.loc[x.loc.length - 1] + ": " : ""}${x.msg}` : JSON.stringify(x))).join(" ");
  return d.msg || String(d);
}

export const fmt = (n, d = 2) => (n == null || Number.isNaN(n) ? "—" : Number(n).toLocaleString("en-MY", { minimumFractionDigits: d, maximumFractionDigits: d }));
export const rm = (n) => (n == null ? "—" : `${n < 0 ? "-" : ""}RM${fmt(Math.abs(n))}`);
export const pnlClass = (n) => (n > 0 ? "text-emerald-600" : n < 0 ? "text-red-600" : "text-slate-700");
export const ts = (s) => (s ? new Date(s).toLocaleString("en-GB", { hour12: false }) : "—");
